import { render, staticRenderFns } from "./ConfirmOrder.vue?vue&type=template&id=cbd3f8fc&"
import script from "./ConfirmOrder.vue?vue&type=script&lang=js&"
export * from "./ConfirmOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports